// Central dayjs configuration. Import dayjs from here (`@/lib/dayjs`) instead of
// from 'dayjs' directly so every consumer shares the same plugin setup. This module
// is also imported once for its side effect in `main.tsx`, guaranteeing the plugins
// are registered on the global dayjs singleton before the app renders.
import dayjs from 'dayjs'
import utc from 'dayjs/plugin/utc'
import customParseFormat from 'dayjs/plugin/customParseFormat'

dayjs.extend(utc)
dayjs.extend(customParseFormat)

export type { Dayjs } from 'dayjs'
export default dayjs
